(function() { window.GUID_1c886f16_054a_4a78_9481_f0ed0fa9d5fc = { getGuid: function() { return "1c886f16-054a-4a78-9481-f0ed0fa9d5fc"; } }; })();
var Account;
(function (Account) {
    var desktop;
    (function (desktop) {
        $(function () {
            let returnUrlEncoded = CSParameters.ReturnUrlEncoded;
            let sporteventid = CSParameters.SportEventId;
            let specialMessage = '';
            let specialMessageHidden = $('#SpecialMessage');
            if (specialMessageHidden.length > 0) {
                specialMessage = specialMessageHidden.val();
            }
            var isKiosk = $('#IsKiosk').val() != null && $('#IsKiosk').val() == 'True' ? true : false;
            var cancelUrl = $('#CancelUrl').val() != null ? $('#CancelUrl').val() : '/Leagues';
            $('#TopBar').hide();
            let popup = new CompuSport.Controls.Popup();
            var data = {
                returnUrl: returnUrlEncoded,
                cancelUrl: cancelUrl,
                isKiosk: isKiosk,
                specialMessage: specialMessage
            };
            let navigating = false;
            popup.GetAndShow({
                PopupId: "",
                Data: data,
                Url: CSParameters.RUrl + 'Account/Login/' + sporteventid,
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
            });
            popup.OnShowed = function () {
            };
            popup.OnPosted = function (response) {
                navigating = true;
                /*Etrange, il n'y avait pas cette ligne et ceci faisait en sorte que le returnUrl ne marchait jamais
                mais il semblait ok puisque 99% du temps, le back sur le OnClosed revenait a la bonne place
                mais dans le cas d'un lien direct vers une de nos page, le back netait pas bon*/
                window.location.assign(decodeURIComponent(response.returnUrl));
            };
            popup.OnClosed = function () {
                if (navigating) {
                    return; /*Sinon, le post fait quand meme un back*/
                }
                if (window.history.length > 1) {
                    window.history.back();
                    /*Lag fait en sorte d'éviter une page noir qui mene nul part puisque parfois, on click cancel sur le login et le back mene nul part
                     * puisque l'historique est plus grande que 1 et pourtant, il n'a nul part ou aller, donc, dans ce cas, la popup de login
                     * se close et il se passe rien. En placant un lag, ainsi, si apres 1 sec, rien n'est fait, il retourne au portail et ainsi
                     * il ne jam pas là
                     */
                    CS.Lag(1000, function () {
                        window.location.assign(cancelUrl);
                    });
                }
                else {
                    window.location.assign(cancelUrl);
                }
            };
        });
        let specialMessageHidden = $('#SpecialMessage');
    })(desktop = Account.desktop || (Account.desktop = {}));
})(Account || (Account = {}));

//# sourceMappingURL=Account.desktop.js.map
